import { LoaderCircle } from 'lucide-react';
import { cn } from '~/lib/utils';
export function Spinner({ className }: { className?: string }) {
  return (
    <LoaderCircle
      role="status"
      aria-label="Loading"
      className={cn('size-4 motion-safe:animate-spin', className)}
    />
  );
}
